import {
    PROJECTS_GET_STATUSES_LIST,
    PROJECTS_GET_STATUSES_LIST_SUCCESS,
    PROJECTS_GET_STATUSES_LIST_ERROR
} from './actions_def';

const INIT_STATE = {
    projectsStatuses: [],
    errors: [],
    isLoading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case PROJECTS_GET_STATUSES_LIST:
            return { ...state, isLoading: false };

        case PROJECTS_GET_STATUSES_LIST_SUCCESS:
            return {
                ...state,
                isLoading: true,
                projectsStatuses: action.payload,
            };

        case PROJECTS_GET_STATUSES_LIST_ERROR:
            return { ...state, isLoading: true, error: action.payload };


        default:
            return { ...state };
    }
};
